'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100vw;\n  height: 100%;\n  flex-grow: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-top: 15px;\n  -webkit-overflow-scrolling: touch;\n'], ['\n  width: 100vw;\n  height: 100%;\n  flex-grow: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-top: 15px;\n  -webkit-overflow-scrolling: touch;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Content = _styledComponents2.default.div(_templateObject);

exports.default = Content;